import { ThemeType } from "@itwin/itwinui-react";
import { IModelInfo } from "services/SandboxIModels";

export const getEnvironmentVariables = (theme: ThemeType, selectedImodel?: IModelInfo) => {
  // const selectedImodel = store.getState().activeSandbox?.selectedImodel;
  // const theme = store.getState().settings.theme;

  // IMPORTANT! variable names have to be mangled to break "process.env" pattern
  // otherwise they are substituted to ({}) empty object value during production build with rollup
  // seems to be a bug in vite.js, I did not find a way to whitelist it

  const variables: { [name: string]: string } = {
    [["process", "env", "IMJS_AUTH_CLIENT_CLIENT_ID"].join(".")]: "service-D2NuNdq5Fcbl0RB5c0Tg7FUpU",
    [["process", "env", "IMJS_AUTH_CLIENT_SCOPES"].join(".")]: "aiml:read changedelements:modify changedelements:read clashdetection:read context-registry-service:read-only designelementclassification:modify designelementclassification:read general-purpose-imodeljs-backend imodelaccess:read imodelhub imodeljs-router imodels:modify imodels:read insights:read issues:modify issues:read itwinjs product-settings-service projects:modify projects:read realitydata:modify realitydata:read results-analysis-service savedviews:read transformations:read validation:read",
    [["process", "env", "IMJS_AUTH_AUTHORITY"].join(".")]: "https://ims.bentley.com",
    [["process", "env", "IMJS_AUTH_CLIENT_REDIRECT_URI"].join(".")]: "http://localhost:3000/sign-in",
    [["process", "env", "IMJS_AUTH_CLIENT_LOGOUT_URI"].join(".")]: "http://localhost:3000/sign-out",
    [["process", "env", "IMJS_BING_MAPS_KEY"].join(".")]: "1ySVcDIJC9DEljXwyhV~tU--Dbkx91caO-AOps1M9Q~AjwukGNRiZ4GlVbAAz3GCIQhZgxULS0t4GibCuHV1N_xuA2-qAufG7_4mZxEg7ir",
    [["process", "env", "IMJS_MAP_BOX_KEY"].join(".")]: "sk.eyJ1IjoibGJ1cm4iLCJhIjoiY2wwdjNxZWlnMDF3dzNxcGc4MW9ub3R1aSJ9.mW4Jw9YB8rzYcBqzuQfW4w",
    [["process", "env", "IMJS_CESIUM_ION_KEY"].join(".")]: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0MWY1NmQ3Yi0wNDZjLTQ5NjAtYTkxMy0wOTM4ZGRjZWU0MzYiLCJpZCI6ODYxNDQsImlhdCI6MTY0NzUyODIyOH0.aLlF-pYP1MxN0vkEIPQWdMVf_uXh-FSkcKTmUTcx2SI",
  }

  variables[["process", "env", "THEME"].join(".")] = theme;

  variables[["process", "env", "IMJS_ITWIN_ID"].join(".")] = selectedImodel?.iTwinId ?? "";
  variables[["process", "env", "IMJS_IMODEL_ID"].join(".")] = selectedImodel?.iModelId ?? "";

  return variables;
};
